import Component from '@glimmer/component'
import { service } from '@ember/service'
import type MathsDrivingTestsService from 'teacher-ui-client/services/maths-driving-tests'
import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { RadioButtonGroup } from 'teacher-ui-client/components/base/radio-button-group'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { ReportingUiScopeSelect } from 'teacher-ui-client/components/reporting/ui-scope-select'
import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingExportSelect, type ExportOption } from 'teacher-ui-client/components/reporting/export-select'
import { StudentSearchComponent } from 'teacher-ui-client/components/student-search'
import type Student from 'teacher-ui-client/models/student'
import { not } from 'ember-truth-helpers'

interface Signature {
  Args: {
    students: Student[]
    setDrivingTestsGrade?: (drivingTestGrade: number) => void
    drivingTestsGrade?: number
    showScopePicker?: boolean
    showDatePicker?: boolean
    exportOptions: ExportOption[]
    isDataPresent: boolean
    studentRouteName: string
  }
}

export class ReportingDetailedControls extends Component<Signature> {
  @service mathsDrivingTests!: MathsDrivingTestsService

  get drivingTestsGradeButtons() {
    const drivingTestData = this.mathsDrivingTests.drivingTestData
    if (!drivingTestData) return []

    return drivingTestData.map((dtData) => ({
      text: dtData?.fullName,
      value: dtData.drivingTestGrade,
    }))
  }

  <template>
    <ReportingControls>
      {{#if @setDrivingTestsGrade}}
        <RadioButtonGroup
          data-test-driving-test-grade-select
          @name="driving-test-grade-select"
          @buttons={{this.drivingTestsGradeButtons}}
          @value={{@drivingTestsGrade}}
          @onSelect={{@setDrivingTestsGrade}}
        />
        <ReportingControlsGap />
      {{/if}}

      {{#if @showScopePicker}}
        <ReportingUiScopeSelect class="shrink basis-80" />
        <ReportingControlsGap />
      {{/if}}

      {{#if @showDatePicker}}
        <ReportingPeriodSelect data-test-detailed-date-range />
      {{/if}}

      <ReportingExportSelect @exportOptions={{@exportOptions}} @disabled={{not @isDataPresent}} />

      <ReportingControlsGap />
      <StudentSearchComponent
        @studentRouteName={{@studentRouteName}}
        @students={{@students}}
        @includeSelectAll={{false}}
      />
    </ReportingControls>
  </template>
}

export default ReportingDetailedControls
